export class NPC {
    public food: Phaser.GameObjects.Image;
    public npc: Phaser.Physics.Arcade.Image;
    public rect: Phaser.Geom.Rectangle;
    public served: boolean;
    public goodText: string;
    public badText: string;
    public time: number;
   
    constructor(food: Phaser.GameObjects.Image, npc: Phaser.Physics.Arcade.Image, rect: Phaser.Geom.Rectangle, served: boolean, goodText: string, badText: string, time: number) {
        this.food = food;
        this.npc = npc;
        this.rect = rect;
        this.served = served;
        this.goodText = goodText;
        this.badText = badText;
        this.time = time;
    }
}



// WEBPACK FOOTER //
// ./src/games/DinerGame/objects/NPC.ts